/**
 * Dates as they actually arrive from the API.
 *
 * Firestore timestamps serialise as `{_seconds, _nanoseconds}` over JSON, and
 * different endpoints hand back ISO strings, epoch millis, or an already-built
 * Date. Passing the object shape straight to `new Date()` yields Invalid Date
 * and prints as an empty cell, so every read goes through here.
 */
export function toDate(value?: any): Date | null {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'object') {
    const seconds = value.seconds ?? value._seconds;
    if (typeof seconds === 'number') return new Date(seconds * 1000);
    if (typeof value.toDate === 'function') return value.toDate();
    return null;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}
